<template>
  <div class="format__step">
    <mds-empty-state
      v-if="sourceType === 'performance_report'"
      class="format-empty-state"
      :title="translate('scheduler.modal.format.emptystate.title')"
      :message="translate('scheduler.modal.format.emptystate.message')"
    />
    <template v-else>
      <simple-options-combo
        v-for="(parameter, index) in formatStepInfo"
        :key="index"
        :parameter="parameter"
        :editedFeed="editedFeed"
        v-on="$listeners"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import MdsEmptyState from '@mds/empty-state'
import defaultConfig from '@/components/schedulerModal/config/i18n'
import SimpleOptionsCombo from '@/components/schedulerModal/schedulerSteps/helpers/SimpleOptionsCombo'

export default {
  name: 'FormatStep',
  components: {
    SimpleOptionsCombo,
    MdsEmptyState,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    sourceType: {
      type: String,
      default: '',
    },
    formatStepInfo: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
  },
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    ...mapState({
      editedFeed: (state) => state.cache.cache.editedFeed,
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';
.format__step {
  min-height: 100px;
  height: 100px;
  margin-bottom: $mds-space-2-and-a-half-x;
  overflow-y: auto;
  width: 100%;
}

.format-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: auto;
  max-width: fit-content;
  margin-left: $mds-space-3-x;
  &::v-deep > [class^='mds-empty-state__title'] {
    @include mds-level-5-heading();
    color: $mds-text-color-secondary;
  }
  &::v-deep > [class^='mds-empty-state__message'] {
    @include mds-body-text-s();
    color: $mds-text-color-secondary;
  }
}
</style>
